import React, { useState } from "react";
import { Popover } from "../Popover/Popover";
import { Button } from "../Button/Button";
import { Icon_Warning } from "../Icons/icons";
import "./popconfirm.less";

interface PopconfirmInterface {
   title?: string | React.ReactNode;
   onConfirm?: () => void;
   onCancel?: () => void;
   okText?: string | React.ReactNode;
   cancelText?: string | React.ReactNode;
   placement?: "top" | "left" | "right" | "bottom";
   overlayClassName?: string;
   id?: string;
   key?: string | number;
   style?: React.CSSProperties;
   overlayStyle?: React.CSSProperties;
   dark?: boolean;
   disabled?: boolean;
   disableClosingByClickOutside?: boolean;
   children: React.ReactNode;
}

export const Popconfirm: React.FC<PopconfirmInterface> = ({
   title,
   onConfirm,
   onCancel,
   okText = "OK",
   cancelText = "Cancel",
   placement = "top",
   overlayClassName = "",
   id,
   key,
   style,
   overlayStyle,
   dark = false,
   disableClosingByClickOutside = false,
   disabled = false,
   children,
}) => {
   const [isClosed, setIsClosed] = useState(false);

   const handleConfirm = () => {
      onConfirm && onConfirm();
      setIsClosed(true);
   };

   const handleCancel = () => {
      onCancel && onCancel();
      setIsClosed(true);
   };

   return (
      <Popover
         content={
            <div className="bp2-popconfirm" style={{ ...style }}>
               {title && (
                  <div className="bp2-popconfirm__header">
                     <div className="bp2-popconfirm__header__icon p2">
                        <Icon_Warning fill="var(--third)" />
                     </div>
                     <div className="bp2-popconfirm__header__title p2">{title}</div>
                  </div>
               )}
               <div className="bp2-popconfirm__buttons">
                  <Button
                     className="bp2-popconfirm__buttons__cancel"
                     onClick={handleCancel}
                     buttonType={dark ? "danger" : "default"}
                     size="small"
                  >
                     {cancelText}
                  </Button>
                  <Button
                     className="bp2-popconfirm__buttons__confirm"
                     onClick={handleConfirm}
                     buttonType="primary"
                     size="small"
                  >
                     {okText}
                  </Button>
               </div>
            </div>
         }
         trigger="click"
         placement={placement}
         overlayClassName={`bp2-popconfirm ${dark ? "dark" : ""} ${overlayClassName}`}
         disabled={disabled}
         style={overlayStyle}
         id={id}
         key={key}
         customClose={isClosed}
         setCustomClose={setIsClosed}
         disableClosingByClickOutisde={disableClosingByClickOutside}
      >
         <span className="bp2-popconfirm__trigger" onClick={(e) => e.preventDefault()}>
            {children}
         </span>
      </Popover>
   );
};
